(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/coupon-score/assets/javascripts/coupon-row-sections.js') >= 0) return;  svs.modules.push('/components/tipsen/coupon-score/assets/javascripts/coupon-row-sections.js');
"use strict";


const CouponRowHeader = _ref => {
  let {
    children,
    className
  } = _ref;
  return React.createElement("header", {
    className: "pg_coupon_row_header ".concat(className || '').trim()
  }, children);
};
const CouponRowBody = _ref2 => {
  let {
    children,
    className
  } = _ref2;
  return React.createElement("div", {
    className: "pg_coupon_row_body ".concat(className || '').trim()
  }, children);
};
const CouponRowFooter = _ref3 => {
  let {
    children,
    className
  } = _ref3;
  return React.createElement("footer", {
    className: "pg_coupon_row_footer ".concat(className || '').trim()
  }, children);
};
setGlobal('svs.components.tipsen.couponScore.couponRowSections', {
  CouponRowHeader,
  CouponRowBody,
  CouponRowFooter
});

 })(window);